import React  from "react"; 
import CrearUsuario from "../components/Users/CrearUsuario"; 

const CrearUsuarioPage = () => { 
  return <CrearUsuario />;
};

export default CrearUsuarioPage;
